export const LAST_WORKING_DATE_DIFF_IN_DAYS = 90;
